import React from 'react';
import PropTypes from 'prop-types';
import {Set, Map} from 'immutable';
import pluralize from 'pluralize';
import {DepartmentToggle} from 'components/dashboard/DepartmentToggle';

export default class ManagerDepartmentSelect extends React.PureComponent {
  render() {
    const {selectedDepts, allDepts} = this.props;
    return (
      <div className="manager-department-select">
        <DepartmentPrompt selectedDepts={selectedDepts} allDepts={allDepts} />
        <div className="dept-grid">
          {allDepts.toList().map(d => (
            <DepartmentToggle key={d.id} department={d} selected={selectedDepts.has(d.id)} />
          ))}
        </div>
      </div>
    );
  }
}

export function DepartmentPrompt({selectedDepts, allDepts}) {
  const deptString =
    selectedDepts.size === allDepts.size
      ? 'all departments'
      : `${selectedDepts.size} ${pluralize('department', selectedDepts.size)}`;

  return (
    <div className="department-prompt">
      <div>You are currently viewing {deptString}</div>
      <div>(set via your "Dashboard Mode" in your user profile).</div>
    </div>
  );
}

ManagerDepartmentSelect.propTypes = {
  selectedDepts: PropTypes.instanceOf(Set),
  allDepts: PropTypes.instanceOf(Map),
};
